/* eslint-disable no-console */
import { register } from "register-service-worker";
import store from "@/store";
import { ServiceWorkerType } from "@/utils/utils-types";
import { dropDatabase } from "@/plugins/indexDB";

self.addEventListener("install", () =>
  (self as ServiceWorkerType).skipWaiting()
);

register(`/service-worker.js`, {
  ready() {},
  registered() {},
  cached() {},
  updatefound() {},
  updated(registration) {
    caches
      .keys()
      .then(function(cacheNames) {
        cacheNames.forEach(function(cacheName) {
          caches.delete(cacheName);
        });
      })
      .catch(function(error) {
        console.error("Erro ao limpar o cache:", error);
      });
    store.commit("clearCacheData");
    registration.waiting?.postMessage({ type: "SKIP_WAITING" });
    store.dispatch("openInfoCacheUpdate");
    dropDatabase();
  },
  offline() {},
  error(error) {
    console.error("Error during service worker registration:", error);
  }
});
